export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker не поддерживается')
    return
  }

  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js')
      console.log('[SW] Зарегистрирован:', reg.scope)
    } catch (err) {
      console.error('[SW] Ошибка регистрации:', err)
    }
  })
}